import {API} from '@utils'
//************************************//
export function getConfigurations({ limit, page, sort, filter, withSavedQueries }, callback) {
  // API.get('/settings/inspection/configuration-list', {
  //   params: {
  //     limit,
  //     page,
  //     sort,
  //     filter,
  //     with_saved_queries: withSavedQueries
  //   }
  // })
  //   .then(function ({data}) {
      callback({
        list: [
          {
            id: 1,
            name: 'Flowdit Standard Configuration',
            created_by: 'System',
            created_date: '-',
            checklist_count: 32,
            is_default: true
          },
          {
            id: 2,
            name: 'Flowdit Standard Configuration',
            created_by: 'Mr.serado midal',
            created_date: '23/12/2025',
            checklist_count: 32,
            is_default: false
          },
          {
            id: 3,
            name: 'Flowdit Standard Configuration',
            created_by: 'Mr.serado midal',
            created_date: '23/12/2025',
            checklist_count: 32,
            is_default: false
          }
        ],
        pagination: {
          total: 25,
          limit: 25,
          current_page: 1,
          total_pages: 1
        }
      })
    // })
    // .catch(function (res) {})
}
//************************************//
export function _getPlansData(callback) {
  API.get(`/settings/organization/plans`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export function _getIntegrations(callback) {
  API.get(`/settings/integrations`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export function _getIntegration(key, callback) {
  API.get(`/settings/integrations/${key}`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export function _installConfiguration(key, data, callback, callbackError) {
  API.post(`/settings/integrations/${key}/configurations/new`, data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(callbackError)
}
//************************************//
export function _uninstallConfiguration(key, uuid, callback) {
  API.delete(`/settings/integrations/${key}/configurations/${uuid}`)
    .then(function ({data}) {
      callback(data)
    })
}
//************************************//
export function _getConfiguration(key, uuid, callback) {
  API.get(`settings/integrations/${key}/configurations/${uuid}`)
    .then(function ({data}) {
      callback(data)
    })
}
//************************************//
export function _getChildStructureDetails(id, callback, finishCallback = () => {}) {
  API.get(`/resources/sites/structures/${id}/columns`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
    .finally(() => finishCallback())
}
//************************************//
export function _getSiteDetails(id, callback, finishCallback = () => {}) {
  API.get(`/resources/sites/${id}`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
    .finally(() => finishCallback())
}
export function _getStructureData(id, callback, finishCallback) {
  const data = {
    title: "Site V2",
    structure: [
      {
        id: 2,
        title: "Customer1",
        options: {
          title: [
            0,
            1
          ],
          basic_table_columns: []
        },
        is_site: false,
        parent_id: 1,
        children: [3],
        columns: [
          {
            id: 65,
            key: "first_name",
            title: "first_name",
            type: "text",
            required: false,
            unique: false
          },
          {
            id: 66,
            key: "last_name",
            title: "last_name",
            type: "text",
            required: false,
            unique: false
          }
        ]
      }
    ]
  }
  callback(data)
}
//************************************//

export function _addStructure(data, callback, finishCallback) {
  API.post(`/resources/sites/structures/new`, data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
    .finally(() => finishCallback())
}
//************************************//
export function _archiveStructure(id, callback) {
  API.delete(`/resources/sites/structures/${id}`)
    .then(function ({data}) {
      callback(data)
    })
}
//************************************//

export function _updateStructure(id, data, callback, finishCallback) {
  API.put(`/resources/sites/structures/${id}`, data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
    .finally(() => finishCallback())
}
//************************************//
export function _getSettingsRating(callback) {
  API.get(`/checklist/settings/ratings`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export function _saveSettingsRating(data, callback) {
  const formData = new FormData()
  if (_.size(data.icons) > 0) {
    _.forEach(data.icons, (file, id) => {
      formData.append(`icons[${id}]`, file)
    })
  }
  if (_.size(data.rating) > 0) {
    formData.append("rating", JSON.stringify(data.rating))
  }
  if (_.size(data.order) > 0) {
    formData.append("order", JSON.stringify(data.order))
  }
  API.post(`/checklist/settings/ratings`, formData)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export function _translateRatingScale(lang, data, callback) {
  API.put(`/checklist/settings/ratings/${lang}`, data)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export function _getMyWorkspaces(callback) {
  API.get(`/settings/workspaces/my-workspaces`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
export function _createNewWorkspace(data, callback, callbackErr) {
  API.post('/settings/workspaces/new', data)
    .then(function ({data}) {
      callback()
    })
    .catch(function ({data}) {
      callbackErr(data.data)
    })
}
//************************************//
export function _getSettingStorage(callback) {
  API.get(`/settings/organization/storage-usage`)
    .then(function ({data}) {
      callback(data)
    })
    .catch(function (res) {})
}
//************************************//
